import { useState, useCallback } from 'react';

const KEY = 'gs_hub_favorites';

export function useFavorites() {
  const [favs, setFavs] = useState<string[]>(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]') as string[];
    } catch {
      return [];
    }
  });

  const toggle = useCallback((id: string) => {
    setFavs((prev) => {
      const next = prev.includes(id) ? prev.filter((f) => f !== id) : [...prev, id];
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);

  const isFav = (id: string) => favs.includes(id);
  return { favs, toggle, isFav };
}
